/* Native footer disclosure state only; no commerce or account behavior. */
(() => {
  const initialize = (root) => {
    root.querySelectorAll('[data-mpk-footer-disclosures]').forEach((nav) => {
      if (nav.dataset.disclosuresReady) return;
      nav.dataset.disclosuresReady = 'true';
      const disclosures = Array.from(nav.querySelectorAll('.mpk-footer-details'));
      const desktop = window.matchMedia('(min-width: 750px)');
      const sync = () => {
        disclosures.forEach((details) => {
          if (desktop.matches) details.removeAttribute('name');
          else details.setAttribute('name', 'mpk-footer-sections');
          details.open = desktop.matches;
        });
      };
      disclosures.forEach((details) => details.addEventListener('toggle', () => {
        if (desktop.matches || !details.open) return;
        disclosures.forEach((other) => { if (other !== details) other.open = false; });
      }));
      sync();
      desktop.addEventListener('change', sync);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
